import * as React from "react";
import { SVGProps, memo } from "react";

const SvgArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m11.983 8.865 8.055 8.055a.9.9 0 1 0 1.273-1.273l-8.48-8.48a1.2 1.2 0 0 0-1.697 0L2.69 15.614a.9.9 0 1 0 1.273 1.272l8.02-8.02Z"
      fill="#637182"
    />
  </svg>
);

const Memo = memo(SvgArrowUp);

export default Memo;
